import React, { useState, useContext } from 'react';
import "../Styles.css";
import "../../../ui-styles/list/EditProfileImage.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import "../../doctor/doctorProfile/doctorProfile.css";
import "../../../ui-styles/profile/VrtclProfile.css";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import { updateProfile } from "../../../actions/users";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { dateFormat, getAge } from "../../../lib/functions";
import Loader from "../../../lib/ui/loader/Loader";
// import { OffLineAPI } from '../../../offline-auth/api';
import EditPatientProfile from "./components/EditPatientProfile";
import DrugAllergies from "./components/DrugAllergies";
import { toast } from 'react-toastify';
import { validateEmail, validateLetters, validateDate } from '../../../lib/validation';
// import config from '../../../config.json';
import { isValidPhoneNumber } from 'react-phone-number-input';

import { Auth } from "aws-amplify";
import ProfileImage from "../../common/profileImage";
import { addrLangObj } from '../../../locale/address';
import { parsePhoneNumber } from 'react-phone-number-input';

const PatientProfile = (props) =>
{
    const [ editProfile, setEditProfile ] = useState(false);
    const { l } = useContext(LangCtx);
    const al = addrLangObj[ l.locale ];
    const { payload, getPayLoad } = useContext(PayLoadCtx);
    const [ loading, setLoading ] = useState(false);
    const [ current, setTab ] = useState("MP");
    const [ errorMsg, setErrorMsg ] = useState(null);
    const [ error, setError ] = useState({});
    // const [ patient, setPatient ] = useState({});
    const [ drugs, setDrugs ] = useState(null);
    const [ editedPatient, setEditedPatient ] = useState({});
    // const [ image, setImage ] = useState(null);


    // useEffect(() =>
    // {
    //     loadPatient();
    // }, []);

    // const loadPatient = () =>
    // {
    //     setLoading(true);
    //     getUserDetails(payload.userId).then(res =>
    //     {
    //         setLoading(false);
    //         if (res.status && res.data)
    //         {
    //             setPatient({ ...res.data, phone: res.data?.countryCode ? `+${res?.data?.countryCode}${res?.data?.phone}` : res?.data?.phone });
    //             setEditedPatient({ ...res.data, phone: res.data?.countryCode ? `+${res?.data?.countryCode}${res?.data?.phone}` : res?.data?.phone });
    //             if (res && res.data && res.data.profileImage && res.data.profileImage.key)
    //             {
    //                 setImage('../uploads/profile/' + res.data.profileImage.key);
    //             }
    //         }
    //     }).catch(err =>
    //     {
    //         setLoading(false);
    //         toast.error(err.errorMessage, {
    //             position: toast.POSITION.TOP_RIGHT
    //         });
    //         console.log("err ==== ", err);
    //     });
    // };

    const handleEditProfle = () =>
    {
        setEditProfile((prevState) => {
            if (!prevState) {
                setEditedPatient({
                    ...payload,
                    phone: payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` :payload?.phone,
                });
            }
            return !prevState;
        });
        setError({})
    };

    const handleChange = (name, value) =>
    {
        let _editedPatient = { ...editedPatient };
        _editedPatient = {
            ..._editedPatient,
            [ name ]: value
        };
        setEditedPatient(_editedPatient);
    };

    /*   const handleDrugChange = (name, value, i) => {
           let _drugs = [...drugs];
           _drugs[i] = {
               ..._drugs[i],
               [name]: value
           }
           setDrugs(_drugs);
       }

       const removeLicense = (i) => {
           if (i > 0) {
               let _drugs = [...drugs];
               _drugs.splice(i, 1);
               setDrugs(_drugs);
           }
       }*/

    const handlePhoneChange = (value) =>
    {
        setEditedPatient((prevState) =>
        {
            return { ...prevState, phone: value };
        });

        if (value && (value !== "" || value !== undefined))
        {
            if (!isValidPhoneNumber(value))
            {
                setError((prevState) => ({
                    ...prevState,
                    phone: 'Please Enter Valid Phone Number',
                }));
                setErrorMsg(l.pls_check_ph_number);
            } else
            {
                setError((prev) => ({
                    ...prev,
                    phone: ''
                }));
                setErrorMsg('');
            }

        }
        else
        {
            setError((prevState) => ({
                ...prevState,
                phone: 'Please Enter Phone Number'
            }));
            setErrorMsg('');
        }
    };

    const handleAlternatePhoneChange = (value) =>
    {
        setEditedPatient((prevState) =>
        {
            return { ...prevState, alternatePhoneNumber: value };
        });

        if (value && (value !== "" || value !== undefined))
        {
            if (!isValidPhoneNumber(value))
            {
                setError((prev) => ({
                    ...prev,
                    alternatePhone: l.pls_enter_validalterphne,
                }));
                setErrorMsg(l.pls_check_ph_number);
            } else
            {
                setError((prev) => ({
                    ...prev,
                    alternatePhone: ''
                }));
                setErrorMsg('');
            }

        }
        else
        {
            setError((prev) => ({
                ...prev,
                alternatePhone: '',
            }));
            setErrorMsg('');
        }
    };

    const validateForm = () =>
    {
        let _error = {};
        let returnValue = true;

        if (editedPatient.title === '' || editedPatient.title === null)
        {
            _error[ 'title' ] = l.pls_ent_title;
            returnValue = false;
        }
        if (editedPatient.firstName === '' || editedPatient.firstName === null)
        {
            _error[ 'firstName' ] = l.pls_ent_fName;
            returnValue = false;
        }
        else if (!validateLetters(editedPatient.firstName))
        {
            _error[ 'firstName' ] = l.pls_ent_letters_fName;
            returnValue = false;
        }
        if (editedPatient.lastName === '' || editedPatient.lastName === null)
        {
            _error[ 'lastName' ] = l.pls_ent_lName;
            returnValue = false;
        }
        else if (!validateLetters(editedPatient.lastName))
        {
            _error[ 'lastName' ] = l.pls_ent_letters_lName;
            returnValue = false;
        }
        if (editedPatient.gender === '' || editedPatient.gender === null)
        {
            _error[ 'gender' ] = l.pls_sel_gender;
            returnValue = false;
        }
        if (editedPatient.dob === '' || editedPatient.dob === null)
        {
            _error[ 'dob' ] = l.pls_sel_dob;
            returnValue = false;
        }
        else if (!validateDate(editedPatient.dob))
        {
            _error[ 'dob' ] = l.pls_check_dob;
            returnValue = false;
        }
        if (editedPatient.bloodgroup === '' || editedPatient.bloodgroup === null)
        {
            _error[ 'bloodgroup' ] = l.pls_sel_bldgp;
            returnValue = false;
        }
        if (editedPatient.email === '' || editedPatient.email === null)
        {
            _error[ 'email' ] = l.pls_check_email;
            returnValue = false;
        }
        else if (!validateEmail(editedPatient.email))
        {
            _error[ 'email' ] = l.pls_check_email;
            returnValue = false;
        }
        if (editedPatient.phone && !isValidPhoneNumber(editedPatient.phone))
        {
            setErrorMsg(l.pls_check_ph_number);
            returnValue = false;
        }

        // if (editedPatient.country === '' || editedPatient.country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (editedPatient.stateName === '' || editedPatient.stateName == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (editedPatient.city === '' || editedPatient.city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        // if (editedPatient.pincode === '' || editedPatient.pincode == null) {
        //     _error['pincode'] = l.pls_entr_pin
        //     returnValue = false
        // }
        // else if (!validatePincode(editedPatient.pincode)) {
        //     _error['pincode'] = l.pls_check_pin
        //     returnValue = false
        // }
        setError(_error);
        console.log('errr in pateint side----------', _error);
        return returnValue;
    };

    const handleUpdatePatient = (e) =>
    {
        e.preventDefault();
        try
        {
            // let _error = {};
            if (validateForm())
            {
                // const phoneNumber = parsePhoneNumber(editedPatient?.phone);
                if (!editedPatient?.phone || editedPatient.phone.trim() === '') {
                    setErrorMsg("Please enter the phone number.");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                }
        
                const phoneNumber = parsePhoneNumber(editedPatient?.phone);
                if (!phoneNumber) {
                    setErrorMsg("Please enter a valid phone number.");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                }
                const countrycode = phoneNumber?.countryCallingCode.toString();
                const number = phoneNumber.nationalNumber;
                setLoading(true);
                let body = {
                    // clinicID: editedPatient.clinic,
                    //    clinic: clinic,
                    consultRole: 'patient',
                    title: editedPatient.title,
                    firstName: editedPatient.firstName.trim(),
                    lastName: editedPatient.lastName.trim(),
                    countryCode: countrycode,
                    email: editedPatient.email.trim(),
                    phone: number ? number : '',
                    alternatePhoneNumber: editedPatient?.alternatePhoneNumber ? editedPatient?.alternatePhoneNumber : '',
                    gender: editedPatient.gender.trim(),
                    bloodgroup: editedPatient.bloodgroup,
                    dob: editedPatient.dob,
                    drugAllergies: drugs,
                    address: editedPatient?.address ? editedPatient.address : '',
                    country: editedPatient.country ? editedPatient.country : '',
                    stateName: editedPatient.stateName ? editedPatient.stateName : '',
                    city: editedPatient.city ? editedPatient.city : '',
                    pincode: editedPatient.pincode ? editedPatient.pincode : '',
                };

                if (process.env.REACT_APP_isOffline === "true")
                {
                    updateProfile(body).then(res =>
                    {
                        setLoading(false);
                        if (res.status)
                        {
                            toast.success(l.upd_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            // setPatient(null);
                            setEditProfile(prevState => !prevState);
                            getPayLoad();
                            // loadPatient();
                            // handleEditProfle();
                        }
                    }).catch(err =>
                    {
                        setLoading(false);
                        let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.unable_upd_patient;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setErrorMsg(msg);
                    });
                } else
                {
                    Auth.currentAuthenticatedUser().then(user =>
                    {
                        Auth.updateUserAttributes(user, {
                            'custom:fname': editedPatient.firstName.trim(),
                            // 'custom:lname': editedPatient.lastName.trim(),
                            // 'custom:email': editedPatient.email.trim(),
                            // 'custom:dob': editedPatient.dob.toString(),
                            // 'custom:gender': editedPatient.gender.trim(),
                            // 'custom:Country': editedPatient.country,
                            // 'custom:State': editedPatient.stateName,
                            // 'custom:District': editedPatient.city
                        }).then(result =>
                        {
                            updateProfile(body).then(res =>
                            {
                                setLoading(false);
                                if (res.status)
                                {
                                    toast.success(l.upd_succ, {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                    // setPatient(null);
                                    setEditProfile(prevState => !prevState);
                                    getPayLoad();
                                    // loadPatient();
                                    // handleEditProfle();
                                }
                            }).catch(err =>
                            {
                                console.log("errorin update ========", err);
                                setLoading(false);
                                let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.unable_upd_patient;
                                toast.error(msg, {
                                    position: toast.POSITION.TOP_RIGHT
                                });
                                setErrorMsg(msg);
                            });
                        });
                    });
                }
            }
            else
            {
                if (errorMsg != null)
                {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err)
        {
            console.log("err12=======", err);
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT
            });
            setErrorMsg(l.went_worng_pls_try_again);
        }
    };


    return (
        loading ? <Loader /> : payload != null ?
            <div className="baseContainer">
                <div className="hdngTopCol colBlock ">
                    <div className="hdngTopBox etcPdng">
                        <h2 className="topHdngTxt">{l.prof_details}</h2>
                    </div>
                    <div className="tabCol">
                        <div className="row hndlpdn08">
                            <div className={current === "MP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("MP")}>
                                <span>{l.my_profile}</span>
                            </div>
                            <div className={current === "DA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("DA")}>
                                <span>{l.drug_All}</span>
                            </div>
                        </div>
                    </div>
                </div>


                {current === "MP" &&
                    <div className="myProfleContainer">
                        <div className="vrtclProfileCol">

                            <ProfileImage userDetails={payload} userRole={"P"} />

                            <div className="profileDtlsCol">
                                <div className="profleHdngRow">
                                    <span className="profileSHdgn">{l.contact_details}</span>
                                    <div className="proflieEdit" onClick={handleEditProfle}>
                                        <img src="/images/icons/edit-outline.png" className="inlineIcon invertPrimary" alt="icon" />
                                        <small className="inlinetxt">{l.edit}</small>
                                    </div>
                                </div>

                                <ul className="profileGroupCol">
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_dob}</span>
                                        <span className="profileInfoTxt dark">{payload.dob ? dateFormat(payload.dob) : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_age}</span>
                                        <span className="profileInfoTxt dark">{payload.dob ? getAge(new Date(payload.dob)) : ''}</span>
                                    </li>
                                    {/* <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_dept}</span>
                                <span className="profileInfoTxt dark">Ayurveda</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_licen}</span>
                                <span className="profileInfoTxt dark">State License Number</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.lic_exp}</span>
                                <span className="profileInfoTxt dark">12/12/2040</span>
                            </li> */}
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_phone_no}</span>
                                        <span className="profileInfoTxt dark">{payload.phone ? payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` :payload?.phone : '--'}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.alt_phone_no}</span>
                                        <span className="profileInfoTxt dark">{payload.alternatePhoneNumber ? payload.alternatePhoneNumber : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_email}</span>
                                        <span className="profileInfoTxt dark">{payload.email ? payload.email : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.blood_group}</span>
                                        <span className="profileInfoTxt dark">{payload.bloodgroup ? decodeURIComponent(payload.bloodgroup) : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_address}</span>
                                        <span className="profileInfoTxt dark">{payload.address ? payload.address : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_city}</span>
                                        <span className="profileInfoTxt dark">{payload.city ? al[ payload.city ] : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_state}</span>
                                        <span className="profileInfoTxt dark">{payload.stateName ? al[ payload.stateName ] : ''}</span>
                                    </li>
                                    <li className="profileListItem">
                                        <span className="profileInfoTxt">{l.label_pin}</span>
                                        <span className="profileInfoTxt dark">{payload.pincode ? payload.pincode : ''}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                {current === "DA" && <DrugAllergies />
                }
                {editProfile && <EditPatientProfile editProfile={editProfile} errorMsg={errorMsg} error={error} handleChange={handleChange} handleUpdatePatient={handleUpdatePatient} handleEditProfle={handleEditProfle} data={editedPatient} handlePhoneChange={handlePhoneChange} handleAlternatePhoneChange={handleAlternatePhoneChange} />}
            </div>
            : ''
    );
};

export default PatientProfile;